module.exports = __webpack_public_path__ + "static/media/building.a7868fe0.svg";